import { cn } from './cn';

// Card container with an optional uppercase header. Replaces the
// "card + cardHead" pattern that was duplicated across ~9 components.
//
// The header is a real <h2> rather than a <span>, so a screen reader can use the
// card titles to navigate the page.
export default function Card({
  title,
  actions,
  interactive = false,
  padding = 'md',
  className = '',
  children,
}) {
  const pad = padding === 'none' ? '' : padding === 'sm' ? 'p-3' : padding === 'lg' ? 'p-6' : 'p-5';

  return (
    <section
      className={cn(
        'rounded-lg border border-line bg-surface shadow-e1',
        pad,
        interactive &&
          'transition-[box-shadow,border-color] duration-150 hover:border-line-strong hover:shadow-e2',
        className,
      )}
    >
      {(title || actions) && (
        <header className="mb-4 flex items-center justify-between gap-3">
          {title && (
            <h2 className="font-condensed text-[13.5px] font-bold uppercase tracking-[0.08em] text-ink-3">
              {title}
            </h2>
          )}
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </header>
      )}
      {children}
    </section>
  );
}
